import { IValueGetterList } from '../types';

export const valueSetterList: IValueGetterList = {
    issuedBy: (params: any) => ({ ...params.row, issuedByCompanyName: params.value }),
    issuedTo: (params: any) => ({ ...params.row, issuedToCompanyName: params.value })
};

export const getValueSetter = (key: string) => valueSetterList[key as keyof IValueGetterList];
